<!-- 企业认证 -->
<template>
	<div style="width: 700px;">
		<div style="font-size: 16px;color: #767794;margin-top: 40px;">
			当前认证公司:&nbsp;&nbsp;<span style="cursor:pointer;">{{form1.company_name}}</span>
			<img src="./assets/img/edit.png" style="vertical-align: bottom;margin-left: 10px;" @click="open" />
		</div>
		<el-form class="custom-form" :model="form1" label-width="80px" label-position="top" :rules="rules"
			ref="authForm">
			<el-form-item label="公司邮箱" prop="email" required>
				<el-input v-model="form1.email" placeholder="请输入公司邮箱"></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="verificationCode" required>
				<el-input v-model="form1.verificationCode" placeholder="请输入验证码">
					<template #append>
						<span style="cursor:pointer;" @click="loginEmail()">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;获取验证码&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</span>
					</template>
				</el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;margin-top: 80px;">
			<el-button style="width: 48%;height: 50px;background: linear-gradient(to right, #5ca4ef, #b240ff);
		    -webkit-background-clip: text;background-clip: text;color: transparent;background-color: rgba(210, 211, 208, 0.1);border: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
          border-radius: 10px;" type="primary" @click="goBack">更换其他验证方式</el-button>
			<el-button style="width: 48%;height: 50px;background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
		  border: transparent;border-radius: 10px;" type="primary" @click="handleNext">开始验证</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification,
		getEmail,
		getEmailbox
	} from '@/api/email'
	export default {
		data() {
			const validateIdCard = (rule, value, callback) => {
				const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!value) {
					return callback(new Error("请输入邮箱地址"));
				} else if (!reg.test(value)) {
					return callback(new Error("请输入正确的邮箱地址"));
				} else {
					callback();
				}
			};

			return {
				form: {},
				form1: {
					company_name: "",
					email: "",
					verificationCode: "",
				},
				// 验证规则配置
				rules: {
					company_name: [{
							required: true,
							message: "请输入公司邮箱",
							trigger: "blur"
						},
						{
							min: 2,
							max: 50,
							message: "公司名称长度在2-50个字符之间",
							trigger: "blur",
						},
					],
					email: [{
				required: true,
				validator: validateIdCard,
				trigger: "blur"
			}],
			verificationCode: [{
				required: true,
				message: "请输入验证码",
				trigger: "blur"
			}],
		}
			};
		},
		created() {
			this.form = JSON.parse(this.$route.query.form)
			this.form1.company_name = this.form.company_name
		},
		methods: {
			open() {
				this.$prompt('请输入公司名称', '编辑', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					getCertification({
						company_name: value,
					}).then(async res => {
						if (res.data.code === 1) {
							this.form1.company_name = res.data.data.company_name
							this.form.company_name = res.data.data.company_name
						} else {
							this.form1.company_name = this.form.company_name
							this.$message({
								type: 'info',
								message: '您输入的公司不存在！'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消修改'
					});
				});
			},
			loginEmail() {
				getEmail({
					email: this.form1.email,
				}).then(async response => {
					if (response.data.code === 1) {
						this.$message({
							type: 'success',
							message: '验证码发送成功'
						});
					}
				})
			},
			goBack() {
				this.$confirm('确认更换其他验证方式吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/verifyCompany/businessVerificationFunc',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			handleNext() {
				// 触发表单验证
				this.$refs.authForm.validate((valid) => {
					if (valid) {
						getEmailbox({
							company_name: this.form1.company_name,
							email: this.form1.email,
							captcha: this.form1.verificationCode
						}).then(async res => {
							if (res.data.code === 1) {
								this.$message({
									type: 'success',
									message: '验证成功'
								});
								this.$router.push({
									path: '/talent',
								});
							} else {
								this.$message({
									type: 'info',
									message: '验证失败'
								});
							}
						})
					} else {
						// 验证失败
						console.log("表单验证失败");
						return false;
					}
				});
			},
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 18px;
		font-size: large;
		background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-left: 20px;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}
</style>